import { useBrandThemeStore } from '@@fire-b2b/stores/brandTheme'

export default defineNuxtPlugin((nuxtApp) => {
  const brandThemeStore = useBrandThemeStore()

  function updateBrandColor() {
    const colorRgb = brandThemeStore.configuredTheme.colorRgb
    const lightBackgroundGradientColorRgb = brandThemeStore.configuredTheme.lightBackgroundGradientColorRgb
    const darkBackgroundGradientColorRgb = brandThemeStore.configuredTheme.darkBackgroundGradientColorRgb

    document.documentElement.style.setProperty('--brand-color', colorRgb ?? null)
    document.documentElement.style.setProperty(
      '--brand-background-gradient-color--light',
      lightBackgroundGradientColorRgb ?? null,
    )
    document.documentElement.style.setProperty(
      '--brand-background-gradient-color--dark',
      darkBackgroundGradientColorRgb ?? null,
    )
  }

  // NOTE: after initial app mount
  nuxtApp.hook('app:mounted', () => {
    updateBrandColor()
  })

  // NOTE: after initial page load
  nuxtApp.hook('app:suspense:resolve', () => {
    updateBrandColor()
  })

  // NOTE: on error page
  nuxtApp.hook('app:error', () => {
    updateBrandColor()
  })

  // NOTE: after each page navigation
  nuxtApp.hook('page:finish', () => {
    updateBrandColor()
  })
})
